<div class="bg-primary text-white py-4 pb-4">
    <div class="container">
        <h4 class="mb-0 text-center fw-semibold text-white">
            AntiqueSoft Cloud Software Licensing Terms and Conditions
        </h4>
    </div>
</div>
<div class="container my-4">
    <div class="bg-white border rounded p-4">

        <h5 class="text-primary fw-semibold mb-2">Access Grant</h5>
        <p>
            Access to the AntiqueSoft Cloud Software is granted to the Company/Antique Mall/ Antique Store/ Market /
            Corporation (hereinafter referred to as the “User”) based on the General Terms and Conditions outlined in
            the AntiqueSoft Cloud Software License and Services Agreement (hereinafter referred to as the “Agreement”)
            executed between the User and E-SoftSys, LLC (hereinafter referred to as the “Licensor”), the developer and
            provider of the AntiqueSoft cloud-based application.
        </p>
        <p class="mb-4">
            The initial and renewal terms of this Agreement shall be as defined in the specific schedules or Statements
            of Work executed between the User and Licensor, allowing for different term durations and renewal conditions
            based on the User’s selected subscription plan.
        </p>

        <h5 class="text-primary fw-semibold mb-2">License Scope</h5>
        <p class="mb-4">
            The software license issued by the Licensor to the User is a personal, non-transferable, and non-exclusive
            subscription-based license to access and use the cloud-hosted AntiqueSoft application for the User’s
            internal business purposes at the locations specified in the schedules listed in the executed Agreement
            between the User and Licensor.
        </p>

        <h5 class="text-primary fw-semibold mb-2">License Term and Renewal</h5>
        <p class="mb-4">
            The cloud software license between the User and Licensor will be governed by the license terms listed under
            Section 8.a of the General Terms and Conditions in the executed Agreement. The license will remain in effect
            for the Initial Term specified in the Agreement or applicable schedule. Upon expiration of the Initial Term,
            the Agreement shall automatically renew for successive Renewal Terms of the duration set forth in the
            Agreement, unless either party provides written notice of non-renewal in accordance with the notice period
            defined in the executed Agreement or applicable schedule.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Additional Booths</h5>
        <p class="mb-4">
            Licensor reserves the right to invoice the User for all additional booths added beyond the licensed
            quantity, in accordance with the license terms listed under Section 8.b of the General Terms and Conditions
            in the executed Agreement.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Custom Modifications and Services</h5>
        <p class="mb-4">
            Any custom configurations, integrations, or additional services requested by the User and provided by the
            Licensor will be billed at the then-current service rates, as specified in Section 14 of the General Terms
            and Conditions in the executed Agreement.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Governing Law</h5>
        <p class="mb-4">
            This Agreement shall be governed exclusively by the laws of the Commonwealth of Pennsylvania, along with the
            general provisions listed under Section 7 of the General Terms and Conditions in the executed Agreement
            between both parties.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Termination</h5>
        <p class="mb-4">
            Termination of the User’s cloud software access and license shall be governed by the Termination clause
            listed under Section 6 of the executed Agreement between the User and Licensor.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Software Ownership</h5>
        <p class="mb-4">
            The User acknowledges that the AntiqueSoft Cloud Software, including all underlying technology, source code,
            design, structure, and associated intellectual property, remains the sole property of the Licensor, as
            outlined under Section 10 of the General Terms and Conditions in the executed Agreement. No ownership rights
            or interests in the software are transferred or granted to the User under this Agreement, except for the
            limited license to access and use the software as expressly provided herein.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Cancellation</h5>
        <p class="mb-4">
            Any cancellation of the AntiqueSoft Cloud Software subscription by the User shall be governed by the
            cancellation clause listed under Section 12 of the General Terms and Conditions in the executed Agreement.
            The User agrees to provide written notice to the Licensor in accordance with the notice period defined in
            the executed Agreement or applicable schedule. Upon cancellation, the User’s access to the AntiqueSoft Cloud
            Software will be discontinued, and all related fees due to the effective cancellation date shall remain
            payable.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Transfer or Sale</h5>
        <p>
            The User shall not assign, transfer, or convey any rights or obligations under this Agreement, whether by
            operation of law or otherwise, without the prior written consent of the Licensor.
        </p>
        <p>
            In the event of a transfer or sale of the User’s business, assets, or operations that utilize the
            AntiqueSoft Cloud Software, the User must notify the Licensor in writing in accordance with the notice
            period defined in the executed Agreement. Any proposed transferee or purchaser must enter into a new license
            agreement with the Licensor prior to gaining access to or use of the software.
        </p>
        <p class="mb-4">
            Unauthorized transfer or continued use of the AntiqueSoft Cloud Software following such sale or transfer
            shall constitute a material breach of this Agreement and may result in immediate termination of access,
            along with potential legal action by the Licensor to protect its intellectual property and licensing rights.
        </p>

        <h5 class="text-primary fw-semibold mb-2">Data Retention and Access upon Termination</h5>
        <p>
            In the event of license termination or cancellation, the User’s access to the AntiqueSoft Cloud Software
            will be disabled as per the relevant notification period outlined in the executed Agreement. However, the
            User may request continued access to archived historical data hosted by the Licensor. Such access will be
            subject to a one-time setup fee and ongoing monthly archive hosting fees. The User may discontinue archive
            access at any time by providing written notice to the Licensor in accordance with the notice period
            specified in the executed Agreement.
        </p>

    </div>
    <div class="row">
        <div class="col-12 text-end my-3">
            <a class="btn btnAS me-1">Print</a>
            <a class="btn btnAS" [routerLink]="['/login']">Back</a>
        </div>
    </div>
</div>